import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 2px;
`;

export const Bar = styled.div<{$active: boolean}>`
  flex: 1;
  height: 8px;
  border-radius: 2px;
  background: ${({$active, theme}) =>
    $active ? theme.colors.buttons.mainButtonBackground ?? '#2563eb' : '#e5e7eb'};
`;
